// jshint esversion: 8

export default {
  id: state => state.id,
  name: state => state.name,
  logo: state => state.logo
};
